import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

const getGridAttribute = attr => (state, gridName) =>
    state.grid[gridName] && state.grid[gridName][attr];

export const gridExists = (state, name) => !!state.grid[name];
export const getCurrentPage = getGridAttribute('page');
export const getTotalRows = getGridAttribute('totalElements');
export const getPageLength = getGridAttribute('pageLength');
/** Always an array — grid slice may be missing on first paint before registerGrid (useEffect) runs. */
export const getKeys = (state, gridName) => {
	const order = getGridAttribute('order')(state, gridName);
	return Array.isArray(order) ? order : [];
};
export const getSorting = getGridAttribute('sorting');
export const getFilter = getGridAttribute('filter');
export const getLoadData = getGridAttribute('loadData');
export const doesNeedRefresh = getGridAttribute('needsRefresh');
export const isAdvancedSearchOpen = getGridAttribute('advancedSearchOpen');
export const getCountryActionPills = getGridAttribute('countrySummaryActions');
export const getblkSNAckActionPills= getGridAttribute('blkAcknowledgeActions');
export const appliedFilterCount = (state, gridName) => {
    const filters = getFilter(state, gridName);

    if (filters != null && typeof filters === 'object' && !Array.isArray(filters)) {
        return Object.entries(filters).reduce((acc, [key, val]) => {
            if (!val || isEmpty(val) || key === 'searchParam') {
                return acc;
            }
            return acc + 1;
        }, 0);
    }

    return 0;
};

export const hasNoResults = (state, gridName) =>
    !get(state.grid, `${gridName}.pristine`) && getTotalRows(state, gridName) <= 0;

export const getQueryParams = (state, gridName) => {
    const { sortBy, sortOrder } = getSorting(state, gridName) || {};
    const filter = getFilter(state, gridName) || {};

    const query = {
        page: getCurrentPage(state, gridName) ?? 0,
        size: getPageLength(state, gridName) ?? 10,
        ...filter
    };

    if (sortBy && sortOrder) {
        query.sort = `${sortBy},${sortOrder}`;
    }

    return query;
};
